import {Component, Inject, Input, LOCALE_ID, OnInit} from '@angular/core';
import {MenuModule} from "primeng/menu";
import {MenuItem, MessageService} from "primeng/api";
import {FormsModule} from "@angular/forms";
import {TemplateComponent} from "../../template/template.component";
import {Router} from "@angular/router";
import {GlobalService} from "../../../services/global.service";
import {Pages} from "../../../dto/Pages";
import {MenubarModule} from "primeng/menubar";
import {Setting} from "../../../dto/Setting";
import {RestBackendService} from "../../../services/rest-backend.service";
import {NgIf} from "@angular/common";
import {Config} from "../../../services/config.service";

@Component({
    selector: 'app-top-bar',
    standalone: true,
    imports: [
        MenuModule,
        FormsModule,
        MenubarModule,
        NgIf
    ],
    templateUrl: './top-bar.component.html',
    styleUrl: './top-bar.component.css'
})
export class TopBarComponent implements OnInit {
    @Input() top_bar: any = {};
    @Input() top_bar_Link: Pages;
    @Input() items: MenuItem[] | undefined;
    conf: Config = new Config();
    pathName: string = "";
    language: string = "fa";

    constructor(public restBack: RestBackendService,
                public route: Router,
                public global: GlobalService,
                protected messageService: MessageService,
                @Inject(LOCALE_ID) public locale: string) {

    }

    ngOnInit(): void {
        this.language = this.locale.toLowerCase();
        this.pathName = location.pathname;
    }


    changLanguage() {
        let loc = window.location.pathname.split('/')[1];
        this.goToHome();
        setTimeout(() => {
            if (loc.length > 1) {
                window.location.href = window.location.href.replace("/" + loc + "/", "/" + this.language + "/");
            }
        }, 200);


    }

    goToHome() {
        this.route.navigate(["/waiting"]);
        setTimeout(() => {
            this.pathName = location.pathname;
        }, 10)

    }


    goToAboutUs() {
        this.route.navigate(["/about-us"]);
    }

    goToPage(page: Pages) {
        this.navicgatRoot(page);
        setTimeout(() => {
            if (page.type == "SUCCESS_STORY") {
                this.route.navigate(["/success_story/" + page.uid])
            } else if (page.type == "PAGE") {
                this.route.navigate(["/page/" + page.uid])
            } else if (page.type == "FEATURE") {
                this.route.navigate(["/feature/" + page.uid])
            } else if (page.type == "BLOG") {
                this.route.navigate(["/blog/" + page.uid])
            } else if (page.type == "NEWS") {
                this.route.navigate(["/news/" + page.uid])
            } else if (page.type == "CUSTOMER") {
                this.route.navigate(["/customer/" + page.uid])
            }
        }, 10)

    }

    navicgatRoot(page: Pages) {
        if ((this.route.url.startsWith("/success_story") && page.type == "SUCCESS_STORY")
            || (this.route.url.startsWith("/page") && page.type == "PAGE")
            || (this.route.url.startsWith("/feature") && page.type == "FEATURE")
            || (this.route.url.startsWith("/blog") && page.type == "BLOG")
            || (this.route.url.startsWith("/news") && page.type == "NEWS")
            || (this.route.url.startsWith("/customer") && page.type == "CUSTOMER")
        ) {
            this.route.navigate(['/waiting']);
        }

    }

    menuClick() {
        // if (this.pathName != location.pathname)
        //     location.reload();
    }
}
